import { MenuItem } from './interfaces/menu-item.interface';

export const MENU_ITEMS: MenuItem[] = [
  { id: 'profile', title: 'PROFILE', iconName: 'person', path: 'profile' },
  { id: 'clients', title: 'CLIENTS', iconName: 'groups', path: 'teams' },
  { id: 'doubts', title: 'DOUBTS', iconName: 'chat', path: 'doubts' },
  {
    id: 'calendar',
    title: 'CALENDAR',
    iconName: 'calendar_month',
    path: 'calendar'
  },
  { id: 'reviews', title: 'REVIEWS', iconName: 'task', path: 'reviews' },
  { id: 'payments', title: 'PAYMENTS', iconName: 'payments', path: 'payments' },
  { id: 'info', title: 'INFO', iconName: 'info', path: 'info' }
];
